// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Iax_7","largestCol":"styles_largestCol__3Qy9t","smallestCol":"styles_smallestCol__35Jlg"};